import { Extension } from "@tiptap/core";

export type FontSizeOptions = {
  types: string[];
  initialFontSize: string;
};

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    size: {
      /**
       * Set the text color
       */
      setFontSize: (size: string) => ReturnType;
      /**
       * Unset the text color
       */
      unsetFontSize: () => ReturnType;
    };
  }
}

export const FontSize = Extension.create<FontSizeOptions>({
  name: "FontSize",

  addOptions() {
    return {
      types: ["textStyle"],
      initialFontSize: "12",
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: this.options.initialFontSize,
            parseHTML: (element) => {
              const fontSize = element.style.fontSize?.replace(/['"]+/g, "");
              if (!fontSize) return null;
              return fontSize.replace(/pt|px|em|rem/g, "").trim();
            },
            renderHTML: (attributes) => {
              if (!attributes.fontSize) return {};
              const numericValue = String(attributes.fontSize)
                .replace(/pt|px|em|rem/g, "")
                .trim();
              return {
                style: `font-size: ${numericValue}pt`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
        (fontSize) =>
        ({ chain }) => {
          return chain().setMark("textStyle", { fontSize }).run();
        },
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain()
            .setMark("textStyle", { fontSize: null })
            .removeEmptyTextStyle()
            .run();
        },
    };
  },
});
